import { Link } from "react-router-dom";

export default function Header({ minimal = false }) {
  return (
    <header className="relative z-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img
            src="/logos/Logotype_BLACK.svg"
            alt="Ariovis"
            className="h-7 w-auto"
            data-testid="header-logo"
          />
          <span className="hidden md:inline-block h-5 w-px bg-slate-300" />
          <span className="hidden md:inline-block text-[11px] tracking-[0.18em] text-slate-500 font-medium uppercase">
            IAM ROI Calculator
          </span>
        </Link>
        {!minimal && (
          <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
            <a href="#methode" className="hover:text-slate-900 transition" data-testid="nav-methode">Méthode</a>
            <a href="#valeur" className="hover:text-slate-900 transition" data-testid="nav-valeur">Valeur</a>
            <a href="https://ariovis.fr/contact" target="_blank" rel="noopener noreferrer" className="hover:text-slate-900 transition" data-testid="nav-contact">Contact</a>
          </nav>
        )}
      </div>
    </header>
  );
}
